import { render, staticRenderFns } from "./UserRideHistory.vue?vue&type=template&id=4998a29f&scoped=true&"
import script from "./UserRideHistory.vue?vue&type=script&lang=js&"
export * from "./UserRideHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4998a29f",
  null
  
)

export default component.exports